module.exports = __webpack_public_path__ + "img/void.fcea9203.png";